import yup from '../../../../helpers/yupInstance';
import type { TFunction } from 'i18next';

export function getAddSubscriptionPlanPriceFormValidation(t: TFunction) {
  return yup.object({
    stripePriceId: yup
      .string()
      .max(256, t('formikValidation.maxLength').replace('{0}', '256'))
      .required(t('formikValidation.stripePriceIdRequired')),
    value: yup.number().required(t('formikValidation.valueRequired')),
    plan: yup.object().required(t('formikValidation.planRequired')),
    current: yup.boolean().required(t('formikValidation.currentRequired')),
  });
}
